import React, { useState } from 'react';
import { Nav, Navbar, Image, Container } from 'react-bootstrap';
import { NavLink, Link } from 'react-router-dom';
import logo from '../../assets/logo-white-without-text.png';

function Navibar() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Navbar
      expanded={expanded}
      expand="lg"
      fixed="top"
      variant="dark"
      className="custom-navbar shadow-lg"
    >
      <Container>
        {/* Логотип и Название - теперь видны всегда */}
        <Navbar.Brand as={Link} to="/" onClick={() => setExpanded(false)} className="d-flex align-items-center fw-bold text-uppercase">
          <Image src={logo} width="38" height="38" className="me-2" />
          <span style={{ fontSize: '1.1rem', letterSpacing: '0.5px' }}>Комплекс строй</span>
        </Navbar.Brand>

        {/* Кнопка бургера */}
        <Navbar.Toggle onClick={() => setExpanded(!expanded)} aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto text-center mt-3 mt-lg-0">
            <Nav.Link as={NavLink} to="/" end onClick={() => setExpanded(false)}>
              Главная
            </Nav.Link>
            <Nav.Link as={NavLink} to="/catalog" onClick={() => setExpanded(false)}>
              Каталог
            </Nav.Link>
            <Nav.Link as={NavLink} to="/about" onClick={() => setExpanded(false)}>
              О нас
            </Nav.Link>
            <Nav.Link as={NavLink} to="/working-area" onClick={() => setExpanded(false)}>
              Где мы работаем
            </Nav.Link>
          </Nav>

          {/* Контакты - скрываем на мобилках внутри меню, если нужно место, 
              но сейчас оставим для удобства */}
          <div className="text-center mt-3 mt-lg-0">
            <a href="tel:+79251431299" className="nav-phone fs-5">
              +7 (925) 143-12-99
            </a>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navibar;
